import {observer} from 'mobx-react-lite';
import React, {useContext, useEffect, useState} from 'react';
import {StoreContext} from './root-store';
import {ViewBase} from '../../../patterns/views/base';
import {Main} from '../../../patterns';
import {GenericError} from './GenericError';
import {LoginPage} from '../user/LoginPage';

export const RequireWeakLogin = observer((props: { children: React.ReactNode }): JSX.Element => {
    const {userStore, sessionStore, azureSsoStore} = useContext(StoreContext);
    const requiresLogin = sessionStore.state === 'no-session';
    const tenantId = azureSsoStore.getTenantId();
    const requireSsoLogin = tenantId && requiresLogin;

    const [isLoadingSso, setIsLoadingSso] = useState(requireSsoLogin);

    useEffect(() => {
        if (requireSsoLogin) {
            userStore.loadSsoUser(tenantId).finally(() => {
                setIsLoadingSso(false);
            });
        } else if (userStore.state === 'no-user' && !requiresLogin) {
            userStore.loadUser();
            sessionStore.extendSession();
        }
    }, []);

    if (isLoadingSso) {
        return <Main isLoading={true}><React.Fragment /></Main>;
    }

    if (requiresLogin) {
        return <LoginPage/>;
    }

    if (userStore.state === 'error') {
        return <ViewBase><GenericError/></ViewBase>;
    }

    if (userStore.state !== 'user-loaded') {
        return <Main isLoading={true}><React.Fragment/></Main>;
    }

    return <React.Fragment>{props.children}</React.Fragment>;
},
);
